// The wait/release timing knobs, in one place. Every knob ships with a
// default; the values are proposals to tune against real-world behavior, not
// constraints — change them here, nowhere else.
export type WaitTuning = {
  // The universal minimum confidence wait: no exit — match, release, or
  // terminal empty, even when the create failed — shows before this. An
  // instant release reads as "no work happened".
  minWaitMs: number;
  // How long a genuinely running search (signal in_progress) may hold the
  // user before releasing anyway. Not the execution timeout — sources keep
  // running server-side after release.
  inProgressCapMs: number;
  // Poll cadence while holding, and once the wait has released.
  holdPollMs: number;
  releasedPollMs: number;
  // The page can stay mounted indefinitely (Ionic retains the view), so
  // polling must end on its own: immediately once the search completes
  // (settled attempts are immutable), or at a hard ceiling that outlives the
  // worker's retry window for failed runs.
  pollCeilingMs: number;
};

export const DEFAULT_WAIT_TUNING: WaitTuning = {
  minWaitMs: 3_000,
  inProgressCapMs: 15_000,
  holdPollMs: 1_000,
  releasedPollMs: 5_000,
  pollCeilingMs: 5 * 60_000,
};
